import sc from 'styled-components';
import { Input } from 'antd';

import React from 'react';
export default sc(Input)`
border: none;
width: 100%;
margin: 0;
border-radius: 0;
outline: none;
padding: 4px;`;
